import { FormGroupAddress, Label } from './styles/common';

export function FormInputAddress({
  label,
  valueAddress,
  valueHouse,
  addressError,
  houseNumberError,
  validAddress,
  validHouseNumber,
  onAddressChange,
  onHouseNumberChange,
  addressId,
  placeholder = '',
  housePlaceholder = '',
}) {
  const handleAddressChange = ({ target: { value } }) => {
    onAddressChange(value);
  };

  const handleHouseNumberChange = ({ target: { value } }) => {
    onHouseNumberChange(value);
  };

  return (
    <div className="row">
      <div className="col-12 col-md-8">
        <FormGroupAddress>
          <Label htmlFor={addressId}>{label}</Label>
          <input
            type="text"
            id={addressId}
            placeholder={placeholder}
            className={`form-control ${addressError ? 'is-invalid' : ''
            } ${validAddress ? 'is-valid' : ''}`}
            onChange={handleAddressChange}
            value={valueAddress}
          />
          <div className="invalid-feedback">{addressError}</div>
        </FormGroupAddress>
      </div>
      <div className="col-12 col-md-4">
        <FormGroupAddress>
          <Label>N.</Label>
          <input
            type="text"
            placeholder={housePlaceholder}
            className={`form-control ${houseNumberError ? 'is-invalid' : ''
            } ${validHouseNumber ? 'is-valid' : ''}`}
            onChange={handleHouseNumberChange}
            value={valueHouse}
          />
          <div className="invalid-feedback">{houseNumberError}</div>
        </FormGroupAddress>
      </div>
    </div>
  );
}
